module.exports = __webpack_public_path__ + "fonts/Lato-Italic.5d22f337.ttf";